const UNITS = {
    "MP 2,5": 'μg/m³N',
    "MP 10": 'μg/m³N',
    "Di&oacute;xido de azufre": 'μg/m³N',
    "Di&oacute;xido de nitr&oacute;geno": 'ppbv',
    "Mon&oacute;xido de carbono": 'ppmv',
    "Ozono": 'ppbv',
};

export const unitSelector = (parameterType) => UNITS[parameterType] ?? '';

export default unitSelector;
